import { Component, Injector, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { assets } from '../../core/constants/assets.const';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, Subscription, take, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { responseStatus } from '../../core/constants/responseStatus.const';
import { CommonResponse } from '../../models/common.model';
import { LoginResponse } from '../../models/loginResponse.model';
import { AuthService } from '../../services/auth.service';
import { SwalAlertService } from '../../services/swalAlert.service';
import { BaseClass } from '../../shared/class/baseClass';
import { NotificationResponse } from '../../models/notification.model';
import { TimeagoPipe } from '../../core/pipe/timeago.pipe';
import { SocketService } from '../../services/socket.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'tusangaire-main',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    MatIconModule,
    MatMenuModule,
    CommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    TimeagoPipe
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent extends BaseClass implements OnDestroy, OnInit {
  protected assets = assets;
  protected sidenavWidth = 200;
  protected destroy$: Subject<boolean> = new Subject<boolean>();
  protected profile: LoginResponse | null = null;
  protected subscriptionSubject$!: Subscription;
  protected notificationListing:any | null = null;
  protected showDot: boolean = false;
  audio = new Audio();
  src = 'assets/sounds/notification-sound1.wav';
  constructor(
    injector: Injector,
    public _authService: AuthService,
    private _logoutAlert: SwalAlertService,
    private _socketService:SocketService,
    public _notifyService: NotificationService,
    private ngZone: NgZone
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.profile = res;
        } else {
          this.getProfile();
        }
      });
    this.subscriptionSubject$ = this._notifyService.showDot
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: boolean) => {
        this.ngZone.run(() => {
          this.getNotification();
          this.showDot = res;
          if (res) {
            this.playAudio();
          }
        });
      });
    this.getNotification();
    this._socketService.initSocket();
    // this.joinRoom();
    this.listenToJoinRoomOk();
    this.firstChatNotificationOk();
  }

  playAudio(): void {
    this.audio.src = this.src;
    this.audio.load();
    this.audio.play();
    this.audio.muted = false;
  }


  getProfile(): void {
    this.spinnerService.addToLoader('getProfile');
    this._authService
      .getProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: LoginResponse) => {
          this.spinnerService.removeFromLoader('getProfile');
          this.profile = res;
          this._authService.profileDetails.next(res);
        },
        error: () => {
          this.spinnerService.removeFromLoader('getProfile');
        }
      });
  }

  getNotification(): void {
    this.spinnerService.addToLoader('getNotification');
    this._authService
      .getHeaderNotification()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: NotificationResponse) => {
          this.spinnerService.removeFromLoader('getNotification');
          this.notificationListing = res.notification.splice(0, 5);
        },
        error: () => {
          this.spinnerService.removeFromLoader('getNotification');
        }
      });
  }

  // private joinRoom(): void {
  //   this._socketService.emitAction('booking', body);
  // }


  private listenToJoinRoomOk(): void {
    this._socketService.onEvent('booking_ok').pipe(take(1)).subscribe({
      next: (res: any) => {        
        if (res) {
          this.toasterService.successToastr(this.translateService.instant('newBooking'));
        }
      },
      error: (err:any) => {
        console.error('Socket listener error:', err);
      }
    });
  }

  private firstChatNotificationOk(): void {
    this._socketService.onEvent('firstChatNotificationOk').pipe(take(1)).subscribe({
      next: (res: any) => {
        if (res) {          
          this.toasterService.successToastr(this.translateService.instant('newChat'));
        }
     
      },
      error: (err:any) => {
        console.error('Socket listener error:', err);
      }
    });
  }


  toggleSidenav(): void {
    this._authService.toggleSidebarView();
  }

  hideDot(): void {
    this.showDot = false;
  }

  logout(): void {
    this._logoutAlert
      .swalAlert('logout')
      .then((res: { value: boolean; isConfirmed: boolean }) => {
        if (res.value && res.isConfirmed) {
          this.spinnerService.addToLoader('logout');
          this._authService
            .logout()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res: CommonResponse) => {
                this.spinnerService.removeFromLoader('logout');
                if (res.statusCode === responseStatus.SUCCESS) {
                  localStorage.removeItem(environment.storageKey);
                  this.toasterService.successToastr(
                    this.translateService.instant('Loggedoutsuccessfully')
                  );
                  this.router.navigate(['/']);
                }
              },
              error: () => {
                this.spinnerService.removeFromLoader('logout');
              }
            });
        }
      });
  }

  
  redirectToPage(data:any):void {
    switch (true) {
    case data.pushType === 1 :
      this.router.navigate(['/bookings/list/0/1']);
      break;
    case data.pushType === 5 :
      this.router.navigate(['/bookings/list/0/1']);
      break;
    case data.pushType === 6 :
      this.router.navigate(['/homestay/list/1']);
      break;
    case data.pushType === 7 :
      this.router.navigate(['/packages/list/0/1']);
      break; 
    case data.pushType === 8:
      this.router.navigate(['/service-provider/list/1']);
      break;  
    case data.pushType === 9:
      this.router.navigate(['/manage-customers/list/1']);
      break;
    case data.pushType === 10:
      this.router.navigate(['/chat']); 
      break;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
